import { Flex } from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';
import { Outlet } from 'react-router-dom';

import { Page } from '../components/Page';
import { RequestList } from '../components/RequestList';
import { useWatcherProvider } from '../hooks/requestWatcher/useWatcherProvider';
import { useDashboard } from '../hooks/useDashboard';

export const RequestsScreen = () => {
  const { isOpen: sidebarIsOpen } = useDashboard();
  useWatcherProvider();

  return (
    <Page title="Request" flex={1} overflowX="auto">
      <Show if={sidebarIsOpen}>
        <RequestList />
      </Show>
      <Flex flex={1} overflowY="hidden">
        <Outlet />
      </Flex>
    </Page>
  );
};
